import { getBaseUrl } from "@/utils/generic";

export async function fetchUser({
  email,
  password,
}: {
  email: string;
  password: string;
}) {
  const res = await fetch(`${getBaseUrl()}/api/auth`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
      password: password,
    }),
  });

  if (!res.ok) {
    const errorBody = await res.json().catch(() => ({}));
    throw new Error(
      errorBody?.message || `Failed to fetch user (${res.status})`
    );
  }

  return res.json();
}
